import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus, Minus } from "lucide-react";
import { faqs } from "../lib/data";

const FAQ = () => {
  const [open, setOpen] = useState(0);

  return (
    <section className="py-24 md:py-36 relative" data-testid="faq">
      <div className="mx-auto max-w-[1600px] px-5 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-14">
          <div className="md:col-span-4">
            <div className="section-label mb-6">◆ Got Questions?</div>
            <h2 className="h-display text-5xl md:text-6xl lg:text-7xl mb-8">
              Clarify <span className="font-serif-i text-[color:var(--nn-muted)]">deliverables</span> before they begin.
            </h2>
            <p className="text-[color:var(--nn-text)]/80 text-sm md:text-base leading-relaxed max-w-sm">
              Six of the most-asked questions from prospective clients and hiring teams. If yours
              isn't here, drop me a note below — I'll add it.
            </p>
          </div>

          <div className="md:col-span-8">
            {faqs.map((f, i) => {
              const isOpen = open === i;
              return (
                <div
                  key={f.q}
                  className="border-b border-[color:var(--nn-border)]"
                  data-testid={`faq-${i}`}
                >
                  <button
                    onClick={() => setOpen(isOpen ? -1 : i)}
                    data-cursor="hover"
                    className="w-full flex items-start justify-between gap-6 py-6 md:py-8 text-left group"
                    aria-expanded={isOpen}
                  >
                    <div className="flex items-baseline gap-6">
                      <span className="font-mono text-xs text-[color:var(--nn-muted)] shrink-0">
                        {String(i + 1).padStart(2, "0")}
                      </span>
                      <span className="font-serif text-2xl md:text-3xl tracking-tight group-hover:text-[color:var(--nn-accent-text)] transition-colors">
                        {f.q}
                      </span>
                    </div>
                    <div
                      className={`w-10 h-10 grid place-items-center rounded-full border border-[color:var(--nn-border)] transition-transform duration-500 ${
                        isOpen ? "rotate-180 bg-[color:var(--nn-accent)] border-[color:var(--nn-accent)] text-white" : ""
                      }`}
                      aria-hidden
                    >
                      {isOpen ? <Minus size={16} /> : <Plus size={16} />}
                    </div>
                  </button>
                  <AnimatePresence initial={false}>
                    {isOpen && (
                      <motion.div
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: "auto", opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
                        className="overflow-hidden"
                      >
                        <p className="pb-8 pl-12 pr-6 text-[color:var(--nn-muted)] leading-relaxed max-w-3xl">
                          {f.a}
                        </p>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
